module.exports = __webpack_public_path__ + "static/media/COTEMAR - HSEQ - COTEPLAY - LOGO V3-11.9ddf17ed.png";